import { useChatChannelsOfType } from '@modules/chat-channels/hooks/useChatChannelsOfType';
import { List } from '@mui/material';
import { ChatChannelType } from 'src/@types/chat';
import { SkeletonConversationItem } from 'src/components/skeleton';
import { ChatNavItem } from './ChatNavItem';
import { ChatNavItemP2PStart } from './ChatNavItemP2PStart';

type Props = {
  type: ChatChannelType;
  p2p?: boolean;
  hasUsers?: boolean;
};

export function ChatNav({ type, p2p, hasUsers }: Props) {
  const channels = useChatChannelsOfType({
    type,
    p2p,
  });

  if (!channels)
    return (
      <List disablePadding>
        <SkeletonConversationItem />
        <SkeletonConversationItem />
        <SkeletonConversationItem />
        <SkeletonConversationItem />
        <SkeletonConversationItem />
      </List>
    );

  return !channels.length && p2p && hasUsers ? (
    <ChatNavItemP2PStart />
  ) : (
    <List disablePadding>
      {channels?.map((channel) => (
        <ChatNavItem key={channel._id} conversation={channel} />
      ))}
    </List>
  );
}
